@if (mode === 'auto') {
  <button
    mat-icon-button
    matTooltip="Refresh every 5 seconds"
    matTooltipPosition="below"
    [color]="refreshSubscription ? 'primary' : null"
    (click)="switchAutoRefresh()">
    <mat-icon>autorenew</mat-icon>
  </button>
}

@if (mode === 'manual') {
  <button
    mat-icon-button
    (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>
}
